import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';
import { HabitDrillsService } from 'src/app/modules/habit-drills/services/habit-drills.service';
import { forkJoin } from 'rxjs';
import { ProfileService } from 'src/app/modules/dashboard/profile/service/profile.service';
import { Store } from 'src/app/core/store/store';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { HandleSubscription } from 'src/app/shared/utils/handle-subscription';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/shared/models/user.model';
import { EventsService } from 'src/app/shared/services/events.service';
import { CommunicationService } from 'src/app/shared/services/communication.service';
declare const window: any;
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent extends HandleSubscription implements OnInit {
  programData: any;
  isBotNewTag:boolean = false;
  isBotEnabled:boolean = false;
  user: any;
  storeData: any;
  hideSidebar = false;
  imgFile;
  showHideCoursesTab = false;
  activationData;
  isleaderboard:any;
  isHiration = false;
  hirationData;
  isHirationTab = false;
  isAssessment = false;
  assessmentData = [];
  optionalModal = false;
  currentBlockItem;
  activationInfo: any;

  constructor(private dashboardService: DashboardService, private authService: AuthService,
    private habitService: HabitDrillsService, private router: Router,
    private profileService: ProfileService, private store: Store, private eventsService: EventsService, private communicationService: CommunicationService) {
    super()
  }
  userGroup: any;
  ngOnInit(): void {
    this.hideSidebar = this.router.url.includes('benchmarking');
    // this.dashboardService.self().subscribe((res) => {
    //   this.user = res;
    // })
    // this.getProgramActivation();
    // this.closesidebarMobile();

    this.store.select('user').pipe(takeUntil(this.unsubscribe$)).subscribe((user: any) => {
      this.user = user;

      // if(this.user){
      //   if((this.user['role'] == 'PARTNER_ADMIN') || (this.user['role'] == 'ADMIN')){
      //     this.router.navigate(['/learning-insights'])
      //   }
      //   else{
      //     this.getProgramActivation();
      //   }
      // }
      if(this.user && this.user.cohorts && this.user.cohorts.length) {
        this.showHideCoursesTab = true;
      }
      if(this.user && this.user.userGroup && this.user.userGroup.length) {
        this.userGroup = this.user.userGroup;
      }
      // if(this.user){
      //   window.dataLayer = window.dataLayer || [];
      //   window.dataLayer.push({
      //     'Customer_Email': `${user.email}`,
      //     'Customer_ID': `${user['_id']}`,
      //     'isDummy':  `${user.isDummyUser}`,
      //   });
      //   console.log(window.dataLayer);
      // }
    });

    this.store.select('activation').pipe(takeUntil(this.unsubscribe$)).subscribe((activation: any) => {
      if(activation && activation[0]) {
        this.activationData = activation[0];
        // console.log(activation, 'activationactivation')
        this.checkHirationTab(activation);
        this.checkAssessmentTab(activation); 
      }
    });

    this.store.select('activationInfo').pipe(takeUntil(this.unsubscribe$)).subscribe((activation: any) => {
      if(activation) {
        this.activationInfo = activation
        this.isleaderboard = this.activationInfo['enableProgramLeaderboard'];
      }
    });

    this.store.select('programData').pipe(takeUntil(this.unsubscribe$)).subscribe((activation: any) => {
      if(activation) {
        this.checkHabitDrillAvailability(activation, this.activationInfo);
      }
    });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if(event.url.includes('dashboard/hiration')) {
          this.isHirationTab = true;
        } else {
          this.isHirationTab = false;
        };
        this.store.select('user').pipe(takeUntil(this.unsubscribe$)).subscribe((user: any) => {
          this.user = user;
          if(this.user){
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'Customer_Email': `${user.email}`,
              'Customer_ID': `${user['_id']}`,
              'isDummy':  `${user.isDummyUser}`,
            });
            // console.log(window.dataLayer);
          }
        });
      }
    });
  }

  getProgramActivation() {
    // let res['data'] = [];
    let activeProgram=[];
    // this.dashboardService.getProgramActivation().subscribe((res:any) => {
    //   res['data'].forEach(element => {
    //     if(element.isActive){
    //       activeProgram.push(element);
    //     }

    //   });
    //   this.isBotEnabled = res?.data[0]?.program?.activation?.isBotEnabled;
    //   this.isBotNewTag = res?.data[0]?.program?.activation?.showNewBotTag;
    //   this.programData = JSON.parse(JSON.stringify(activeProgram));
    //   this.storeData = res;
    //   this.isleaderboard = res['data'][0]['program']['activation']['enableProgramLeaderboard'];
    //   this.checkHabitDrillAvailability(res['data'][0]['program']['dashboard'],res['data'][0]['program']['activation']);
    //   if (res['data'][0]['program']['activation']['activities']) {
    //     this.populateActivityMenuItems(res['data'][0]['program']['activation']['activities']);
    //   }
    //   if (res['data'][0]['program']['activation']['isAddSideBarNavigationButton']) {
    //     this.populateAdditionalMenuItems(res['data'][0]['program']['activation']['sideNavigationButton'])
    //   }
    //   localStorage.setItem('ActivationData',JSON.stringify(this.programData[0]));
    //   this.findAllPrograms();
      
    //   // this.checkHabitDrillAvailability(res['data'][0]['program']['dashboard']);
    //   // this.populateAdditionalMenuItems(res['data'][0]['program']['activation']['sideNavigationButton']);
    //   if(res && res['data'] && res['data'].length) {
    //     this.checkHirationTab(res['data'][0]);
    //     this.checkAssessmentTab(res['data'][0]);
    //   }
    // })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.activationInfo?.['isAddSideBarNavigationButton']) {
        this.populateAdditionalMenuItems(this.activationInfo['sideNavigationButton'])
      }
    }, 1000);
  }
  navigateToDashboard() {
    if(!this.user) {
      window.open(`${environment.mainDomain}?redirectSub=sd`, '_self');
      return;
    }
    if(this.router.url.includes('benchmarking')) {
      this.router.navigateByUrl(`/dashboard`, { state: { reload: false}});
    } else {
      this.router.navigate(['/dashboard'],{ state: { reload: true}});
    }
  }
  // Multiple Program fix
  multipleProgramMenu= false;
  ipjPrograms =[];
  legacyPrograms =[];
  showHeaderDropdown = false;
  findAllPrograms(){
    let allPrograms = [];
    this.ipjPrograms =[];
  this.legacyPrograms =[];
    this.dashboardService.getActivePrograms().subscribe(res => {
      if(res){
        const activeProgram = JSON.parse(localStorage.getItem('ActivationData'));
        const progId= activeProgram['programActivationId'];
        this.multipleProgramMenu= true;
        if(res['data']['ipjmultiplePrograms'] && res['data']['ipjmultiplePrograms'].length>0 ){
          this.ipjPrograms= res['data']['ipjmultiplePrograms'];
          allPrograms.push(res['data']['ipjmultiplePrograms']);
        }
        if(res['data']['multiplePrograms'] && res['data']['multiplePrograms'].length>0){
          this.legacyPrograms= res['data']['multiplePrograms'];
          allPrograms.push(res['data']['multiplePrograms']);
        }

        if(allPrograms.length>1){
          this.showHeaderDropdown= true;
        }else if(allPrograms.length ==1){
          if(allPrograms[0].length>1){
            this.showHeaderDropdown=true
          }
        }
        
        this.ipjPrograms.forEach(element => {
          if(element.programActivationId == progId){
            element.isActive= true;
          }else{
            element.isActive=false;
          }

        })
        this.legacyPrograms.forEach(program => {
          if(program.Standalone){
            let link='/courses/'+program.title.toLowerCase().replaceAll(' ', '-')
            program.link=link
          }else{
            let link='/pathways/'+program.templateName.toLowerCase().replaceAll(' ', '-')
            program.link=link
          }
        })
      }
    })
  }


  additionalMenu=[];
  populateAdditionalMenuItems(res){
    res.forEach((elem) => {
      if(elem.isPublish){
        this.additionalMenu.push(elem)
      }
    })
  }
  reportMenu=[];
  oneMenu=[];
  subTaskMenu=[];
  populateActivityMenuItems(res){
    res.forEach(element => {
      const batches= element.batches;
      this.subTaskMenu=[]
      batches.forEach(batchel => {
        if(batchel.userGroup.includes(this.userGroup))
        this.subTaskMenu.push(batchel)
      });
      if(this.subTaskMenu.length){
        if(element.type == '1 TO 1 SESSION'){
          this.oneMenu.push(this.subTaskMenu);
        }else{
          this.reportMenu.push(this.subTaskMenu);
        }
      }
      
    });
  }
  showHabitDrillMenu = false;
  showCustomHabitDrillMenu = false;
  customHabitDrillMenu='';
  checkHabitDrillAvailability(res, activationRes){
    if(!activationRes?.enableCustomHabitDrillNomenClature){
      res.forEach(element => {
        if(element.courseHabitDrills.length>0){
          this.showHabitDrillMenu= true;
        }
      });
    }else{
      this.showHabitDrillMenu= true;
      this.showCustomHabitDrillMenu= true;
      this.customHabitDrillMenu = activationRes.customHabitNomenclature;
      let routercon = this.router['config'];
      let result = routercon.filter(obj => {
        return obj.path === 'dashboard'
      })
      result[0].children.push({ path: activationRes.customHabitNomenclature, loadChildren: () => import('src/app/modules/habit-drills/habit-drills.module').then(m => m.HabitDrillsModule) })
    // routercon.push({ path: activationRes.customHabitNomenclature, loadChildren: () => import('src/app/modules/habit-drills/habit-drills.module').then(m => m.HabitDrillsModule) })
    // console.log(routercon)
    this.router.resetConfig(routercon);
    // this.router.navigateByUrl(activationRes.customHabitNomenclature)
    }
    
  }

  loadNewIpjProgram(ipjProgram){
    let data = {
      "programActivationId":ipjProgram.programActivationId
    }
    this.dashboardService.updateProgramActivation(data).subscribe(res => {
      if(res){
        console.log('update activation response: ', res);
        this.router.navigate(['/login']);
      }
    })

  }

  sendToBusiness(link){
    let token = localStorage.getItem('UPGRAD_IPJ_TOKEN');
    if(token) {
      window.open(`${environment.businessDomain}${link}?accessToken=${token}`, '_blank');
    }
  }

  testnewtab(url){
    let pattern= /https:/i;
    if(url.match(pattern)){
      window.open(url, "_blank");
    }else{
      url= 'https://'+ url;
      window.open(url, "_blank");
    }
  }
  // closesidebarMobile() {
  //   var element = document.getElementById("ipjSidebar");
  //   element.classList.toggle("hide-on-mobile");
  //   var element2 = document.getElementById("siderbar__overlay");
  //   element2.classList.toggle("d-none");
  //   var element3 = document.getElementById("wrapper__section");
  //   element3.classList.toggle("position-fixed");
  //   var element4 = document.getElementById("iconNavMobile");
  //   element4.classList.toggle("icon-open");
  // }
  logout() {
    this.authService.logout(this.user, this.activationData);
  }

  redirectBusiness() {
    let token = localStorage.getItem('UPGRAD_IPJ_TOKEN');
    if(token) {
      window.open(`${environment.businessDomain}/dashboard?accessToken=${token}`, '_blank');
    }
  }

  // caputre event FAQ click
  faqClick() {
    try {   
      if(this.user && this.activationData){
        let eventData = { 'user': this.user, 'activationData': this.activationData }
        this.eventsService.viewFaqEvent(eventData);
      }
    } catch (err) {
      console.log(err);  
    }
  }

  captureNotesBookmarksEvent(){
    try {   
      if(this.user && this.activationData){
        let eventData = { user: this.user, activationData: this.activationData }
        this.eventsService.notesBookmarksEvent(eventData);
      }
    } catch (err) {
      console.log(err);  
    }
  }

  showProgNav() {
    var x = document.getElementById("program__nav");
    if (x.style.display === "block") {
      x.style.display = "none";
    } else {
      x.style.display = "block";
      // document.getElementById("ipjSidebar").classList.add("hide-on-mobile");
      // document.getElementById("siderbar__overlay").classList.add("d-none");
    }
    // this.findAllPrograms();
    this.store.select('IPJProgram').subscribe((res: any) => {
      this.ipjPrograms = res
    })
    this.store.select('legacyProgram').subscribe((res: any) => {
      this.ipjPrograms = res
    })
  }
  closeProgNav(){
    var x = document.getElementById("program__nav");
    x.style.display = "none";
    this.hideSidebar = false;
  }
 

  checkHirationTab(activation) {
    if(activation) {
      let integretion =  activation.find(d => d.type == "INTEGRATION");
      if(integretion) {
        this.isHiration = true;
        this.hirationData = integretion;
      }
    }
  }

  navHiration(path) {    
    let payload = {
      activationId : this.activationData.programActivationId,
      programDashboardId : this.hirationData.programDashboardId,
      activationDashboardType : this.hirationData.type,
      integrationType : this.hirationData.integration.type,
    }
    if(!this.hirationData.status.started) {
      this.dashboardService.startIntegration(payload).subscribe((res) => {
        if (res.data) {
          const url = this.router.serializeUrl(
            this.router.createUrlTree([`/${path}`, {pid:payload.activationId, pdid:payload.programDashboardId}])
          );
          window.open(url, '_blank');
        }
      })
    } else {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/${path}`, {pid:payload.activationId, pdid:payload.programDashboardId}])
      );
      window.open(url, '_blank');
    }
  }

  checkAssessmentTab(activation) {
    this.assessmentData = [];
    if(activation) {
      activation.forEach(item => {
        if(item.type == 'ASSESSMENT' && item.exercise.enablePdfReport && !item.status.islock) {
          this.assessmentData.push(item);
        }
      });
    }
  }

  navigateToAssessment(item) {
    this.currentBlockItem = item;
    if(item && item.isOptionalToComplete && !this.optionalModal && (!item.status.skipOptionalBlock && !item.status.started)) {
      this.optionalModal = true;
      return;
    }
    if(item && !item.status.started) {
      let obj = { activationId: this.activationData.program.activation._id, programDashboardId: item.programDashboardId, activationDashboardType: 'ASSESSMENT', exerciseId: item.exerciseId };
      this.dashboardService.startExercise(obj).subscribe( res => {
        if(res) {
          this.router.navigate([`/benchmarking/assessment/${item.exerciseId}`]);
        }
      })
    } else if(item && item.status.started){
      this.router.navigate([`/benchmarking/assessment/${item.exerciseId}`]);
    }
  }
  
  // Skip optional block 
  skipOptionalBlock() {
    this.optionalModal = false;
    switch (this.currentBlockItem.type) {
      case 'ASSESSMENT':
        this.skipAssessmentBlock();
        break;
      default:
        break;
    }
  }

  skipAssessmentBlock() {
    let obj = { activationId: this.activationData.program.activation._id, programDashboardId: this.currentBlockItem.programDashboardId, activationDashboardType: 'ASSESSMENT', exerciseId: this.currentBlockItem.exerciseId, skipOptionalBlock: true };
    this.dashboardService.startExercise(obj).subscribe( res => {
      if(res) {
        this.navigateToNextItem();
      }
    });
  }

  navigateToNextItem() {
    localStorage.setItem('skipOptional', 'true');
    window.location.reload();
  }

  // Start current optional item 
  startCurrentBlockItem() {
    this.startBlockItem(this.currentBlockItem.type); 
    this.optionalModal = false;
  }

  startBlockItem(type) {
    switch (type) {
      case 'ASSESSMENT':
        this.navigateToAssessment(this.currentBlockItem);
        break;
      default:
        break;
    }
  }

  // Hide optional modal
  optionalModalHide(v) {
    this.optionalModal = v;
  }
}
